import "./styles.css"
import type { ScrollArrowProps } from "@site-types/components/scrollArrow"

export function ScrollArrow({ href, label }: ScrollArrowProps) {
  return (
    <div className="scroll-for-more">
      <a
        href={href}
        aria-label={label}
      >
        <span className="parent">
          <span className="child" />
        </span>
      </a>
    </div>
  )
}

export default ScrollArrow
